import { apiSlice } from './apiSlice';

const commentApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getAllComments: builder.query({
      query: (_id) => `/notes/${_id}/comments/`,
      providesTags: ['NoteComments'],
    }),

    addComment: builder.mutation({
      query: (data) => {
        const { noteId, body } = data;
        return {
          url: `/notes/${noteId}/comments/`,
          method: 'POST',
          body,
        };
      },
      invalidatesTags: ['NoteComments'],
    }),

    deleteComment: builder.mutation({
      query: ({ noteId, commentId }) => ({
        url: `/notes/${noteId}/comments/${commentId}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['NoteComments'],
    }),

    updateComment: builder.mutation({
      query: ({ noteId, commentId, text }) => ({
        url: `/notes/${noteId}/comments/${commentId}`,
        method: 'PUT',
        body: {
          text,
        },
      }),
      invalidatesTags: ['NoteComments'],
    }),

    likeComment: builder.mutation({
      query: ({ noteId, commentId, likedUserId }) => ({
        url: `/notes/${noteId}/comments/${commentId}/like`,
        method: 'PUT',
        body: {
          likedUserId,
        },
      }),
      invalidatesTags: ['NoteComments'],
    }),

    unlikeComment: builder.mutation({
      query: ({ noteId, commentId, unlikedUserId }) => ({
        url: `/notes/${noteId}/comments/${commentId}/unlike`,
        method: 'PUT',
        body: {
          unlikedUserId,
        },
      }),
      invalidatesTags: ['NoteComments'],
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetAllCommentsQuery,
  useAddCommentMutation,
  useDeleteCommentMutation,
  useUpdateCommentMutation,
  useLikeCommentMutation,
  useUnlikeCommentMutation,
} = commentApi;
